import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import styles from './index.less';
/**
 * 拨打电话的hack组件
 * @param props
 * @returns
 */
export var UITellHack = function (props) {
    var onClick = props.onClick, _a = props.telNumber, telNumber = _a === void 0 ? '' : _a, children = props.children;
    var View = useComponents().View;
    var internalClick = function (e) {
        onClick && e.preventDefault();
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return (React.createElement(View, { className: styles['tel-hack-wrap'], onClick: internalClick },
        React.createElement("a", { className: styles['tel-hack'], href: "tel:" + (telNumber || '') }, children)));
};
